// extracted by mini-css-extract-plugin
export var closeContainer = "styles-module--closeContainer--5fa6a";
export var closeLine = "styles-module--closeLine--f52d4";
export var first = "styles-module--first--340df";
export var highlightedText = "styles-module--highlightedText--a96e5";
export var modalBackground = "styles-module--modalBackground--93dff";
export var modalContent = "styles-module--modalContent--755b1";
export var modalHeader = "styles-module--modalHeader--7744a";
export var second = "styles-module--second--5d42b";